class StaffMember extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;

    this.preview = this.querySelector(".staff-section__preview");
    this.popup = this.querySelector(".staff-section__popup");
    this.closeButton = this.querySelector(".close-button");
    this.backgroundClose = this.querySelector(
      ".staff-section__background-close"
    );

    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.update = this.update.bind(this);

    console.log("StaffMember", this.preview);

    this.preview.addEventListener("click", (e) => {
      this.openPopup();
    });

    this.closeButton.addEventListener("click", (e) => {
      this.closePopup();
    });

    this.backgroundClose.addEventListener("click", (e) => {
      this.closePopup();
    });
  }

  openPopup() {
    this.isOpen = true;
    this.update();
  }

  closePopup() {
    this.isOpen = false;
    this.update();
  }
  update() {
    if (this.isOpen) {
      this.popup.classList.add("open");
      this.popup.classList.remove("closed");
      document.querySelector("body").classList.add("no-scroll");
    } else {
      this.popup.classList.remove("open");
      this.popup.classList.add("closed");
      document.querySelector("body").classList.remove("no-scroll");
    }
  }
}

customElements.define("staff-member", StaffMember);
